import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {ServiceDomainGetSchema} from '../../../../api/DBSchema/ServiceDomain';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {dateAndTimeToString} from '../../../../utils/utils';

const pageSchema = ServiceDomainGetSchema.pages.history;
const pageId = pageSchema.pageId;

function ServiceDomainHistory({
    serviceDomainObject,
}) {
    const { t } = useTranslation();

    const pageData = serviceDomainObject[pageId];

    const createTime = pageData[pageSchema.createTime];
    const lastTime   = pageData[pageSchema.lastTime];

    return (
        <EditorLayout>
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(createTime, true)}
                label={t('SMC_GEN_STATS_CREATETIME')}
            />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(lastTime, true)}
                label={t('SMC_GEN_STATS_LASTMOD')}
            />

        </EditorLayout>
    )
}

export default ServiceDomainHistory;